/**
 * CSV関連処理
 */
$(function () {
    // CSV設定の表示時
    $(document).on('click', '[data-csv-download-setting-modal]', function(e) {
        // 設定モーダルを表示
        _modal.create(this, 'csv-download-setting-modal', ['route', 'path', 'search_form'], true);
    });
    // CSV設定の適用・ダウンロード実行時
    $(document).on('click', '[data-csv-download-save-modal]', function(e) {
        let action = extend_url_query($(this).data('action'));
        let datas = $($(this).data('form')).serializeArray();
        _modal.submit(this, 'csv-download-save-modal', function() {
            post(action, datas);
        });
    });
    // CSV設定の初期化時
    $(document).on('click', '[data-csv-download-delete-modal]', function(e) {
        $('input[name="route"]').val($('#csv-download-setting-modal-initialize').data('route'));
        _modal.submit(this, 'csv-download-delete-modal');
    });
});
